export default {
  system: {
    user: 'Utente',
    level: 'Livello',
    earnPerTap: 'Guadagno per tap',
    coinsToLevelUp: 'Monete per salire di livello',
    profitPerHour: "Profitto all'ora",
    coming1: 'Qualcosa di interessante',
    coming2: 'in arrivo qui presto...',
    close: 'Chiudi',
    friends: 'Amici',
    continue: 'Continua',
  },
  settings: {
    chooseNetwork: 'Scegli la rete',
    chooseLanguage: 'Scegli la lingua',
  },
  popup_CheckTask: {
    join: 'Unisciti',
    check: 'Controlla',
    taskIsNotCompleted: 'Compito non completato',
  },
  popup_levelUp: {
    levelUp: 'Sali di livello!',
    multiTap: 'Multi-tap',
    energyLimit: 'Limite di energia',
  },
  popup_BalanceUp: {
    balanceUp: 'Aggiornamento del saldo!',
    balanceDiffSinceLast: 'La tua ricompensa',
  },
  popup_BalanceTip: {
    tip: 'Aumenta il tuo profitto',
    message: 'Tocca il menu Miniera per acquistare potenziamenti per la tua rete',
    description: 'Guadagna anche quando sei offline fino a 3 ore',
  },
  popup_Bored: {
    header: 'La rana è annoiata!',
    message: 'Gioca con la rana.',
    description: 'Se non si gioca con la rana per 3 ore, il profitto si ferma',
  },
  popup_Hungry: {
    header: 'La rana ha fame!',
    message: 'Dai da mangiare alla rana.',
    description: 'Più amici hai, più monete può portare ogni pasto',
  },
  menu: {
    network: 'Rete',
    mine: 'Miniera',
    earn: 'Guadagna',
    food: 'Cibo',
  },
  tap: {
    bored: 'Annoiato',
    fun: 'Divertente',
  },
  mineMenu: {
    activities: 'Attività',
    investments: 'Investimenti',
    web3: 'WEB3',
    achievements: 'Obiettivi',
  },
  leaderboard: {
    from: 'da',
    beTheFirst: 'Sii il primo!',
  },
  mine: {
    joinOurTG1: 'Unisciti al nostro canale Telegram,',
    joinOurTG2: 'per sbloccare!',
    unlock: 'Sblocca',
  },
  friends: {
    inviteFriends: 'Invita amici!',
    receiveBonuses: 'Tu e il tuo amico riceverete dei bonus',
    inviteFriend: 'Invita un amico',
    withTelegramPremium: 'con Telegram Premium',
    forYouAndYourFriend: 'per te e il tuo amico',
    moreBonuses: 'Più bonus',
    listOfYourFriends: 'Lista dei tuoi amici',
    linkCopied: 'Il link di invito è stato copiato negli appunti!',
    playWithMe:
      'Unisciti a me e gioca per guadagnare token tramite un airdrop!\n' +
      '💰 Prendi il tuo regalo! +3000 monete per i nuovi arrivati\n' +
      '🚀 Hai Telegram Premium? Ottieni +5000 monete!\n',
  },
  earn: {
    moreCoins: 'Guadagna più monete!',
    dailyTasks: 'Compiti giornalieri',
    dailyReward: 'Ricompensa giornaliera',
    tasksList: 'Lista dei compiti',
    joinOurTG: 'Unisciti al nostro canale Telegram',
    followOurX: 'Segui il nostro account X',
    yourAd: 'La tua pubblicità potrebbe essere qui',
    connect: "Contatta l'amministratore del nostro canale Telegram",
  },
  food: {
    hungry: 'Affamata',
    full: 'Sazia',
    frogIsFull: 'La rana è sazia',
    feed: 'Nutri',
    bonus: 'Bonus',
    satiety: 'Sazietà',
    hours: 'ore',
  },
  toast: {
    buyCard: {
      title: 'Obiettivo Sbloccato!',
      subtitle: 'È ora di portare il tuo impero di rane alla grandezza 👑',
    },
    feedFrog: {
      title: 'La rana è felice!',
      subtitle: 'Ottimo lavoro! Nutri il tuo animale domestico per mantenere i sorrisi 🍽️',
    },
  },
};
